import { PageRouteBuilder } from "@common/route/page-route-builder";
import { DeepDiveListPageComponent } from "./deep-dive-list-page.component";

export const deepDiveListPageRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-deep-dive-list-page", DeepDiveListPageComponent)
    .atUrl("/tools/deep-dives")
    .withTitle("Deep Dives")
    .build();
